import { z } from "zod";

/** Preço-base do laboratório por combinação Serviço × Material do cardápio — `materialOptionId`
 *  ausente/null = vale pra qualquer material dessa categoria de serviço. */
export const labPriceListUpsertSchema = z.object({
  serviceCategoryId: z.string().min(1),
  materialOptionId: z.string().min(1).optional(),
  priceCents: z.number().int().min(0).max(100_000_000),
});
export type LabPriceListUpsertInput = z.infer<typeof labPriceListUpsertSchema>;

/** Ajuste percentual global de uma clínica parceira — negativo = desconto, positivo = acréscimo.
 *  Faixa validada: nunca ≤ -100% (zeraria ou inverteria o preço) nem acima de 1000% (sem sentido
 *  comercial, evita erro de digitação silencioso). */
export const clientPricingProfileUpsertSchema = z.object({
  clientOrganizationId: z.string().min(1),
  adjustmentPercent: z.number().gt(-100).max(1000),
});
export type ClientPricingProfileUpsertInput = z.infer<typeof clientPricingProfileUpsertSchema>;

export const clientPriceOverrideSetSchema = z.object({
  clientOrganizationId: z.string().min(1),
  serviceCategoryId: z.string().min(1),
  materialOptionId: z.string().min(1).optional(),
  priceCents: z.number().int().min(0).max(100_000_000),
});
export type ClientPriceOverrideSetInput = z.infer<typeof clientPriceOverrideSetSchema>;

export const clientOrganizationIdInputSchema = z.object({
  clientOrganizationId: z.string().min(1),
});
export type ClientOrganizationIdInput = z.infer<typeof clientOrganizationIdInputSchema>;

// ─── Tabelas de preço nomeadas (alternativa mais simples que config por clínica) ───

export const priceTableCreateSchema = z.object({
  name: z.string().min(1).max(80),
  adjustmentPercent: z.number().gt(-100).max(1000).default(0),
});
export type PriceTableCreateInput = z.infer<typeof priceTableCreateSchema>;

export const priceTableRenameSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1).max(80).optional(),
  adjustmentPercent: z.number().gt(-100).max(1000).optional(),
});
export type PriceTableRenameInput = z.infer<typeof priceTableRenameSchema>;

export const priceTableIdInputSchema = z.object({
  priceTableId: z.string().min(1),
});
export type PriceTableIdInput = z.infer<typeof priceTableIdInputSchema>;

export const priceTableOverrideSetSchema = z.object({
  priceTableId: z.string().min(1),
  serviceCategoryId: z.string().min(1),
  materialOptionId: z.string().min(1).optional(),
  priceCents: z.number().int().min(0).max(100_000_000),
});
export type PriceTableOverrideSetInput = z.infer<typeof priceTableOverrideSetSchema>;
